import React, { useContext, useEffect, useRef, useState } from 'react';

import OfferBanner from '../OfferBanner';
import { AlertWrapper, TableWrapper } from '../UI/styledConstants';
import { Wrapper } from './style';
import { clickOutside, getLocation, isEmpty, overLayers } from '../../utils/common';
import PayModal from './PayModal';
import AddBeneficiaryModal from './AddBeneficiary';
import OtpModal from './OtpModal';
import Conform from './Conform';
import Loader from '../UI/Loader/Loader';
import Receipt from './Receipt';
import IconClose from '../../assets/images/IconClose';
import Pagination from '../Pagination/Pagination';
import { GlobleContaxt } from '../../Context/GlobleContaxt';
import user from "../../assets/images/circle-user_.svg";
import userWallet from "../../assets/images/wallet.svg";

import SelectDeviceType from '../AEPS/SelectDeviceType';
import CaptureFingerprint from '../AEPS/CaptureFingerprint';


import { Capture, checkSenderRegister, getListing, registerSender_, verifyTxnOtp } from './SendmoneyRoundPay';
import Timer from '../Addmoney/Timer';
import Input from '../UIbox/Input';
import RadioButtonConfirm from '../UI/RadioButtonConfirm';


const initControls = {
	mobileNumber: '',
	lastName: '',
	firstName: '',
};

export default function Sendmoney({ className = '' }) {
	const [senderMobile, setSenderMobile] = useState('');
	const [activeMobilePop, setActiveMobilePop] = useState(false);
	const [beneficiaryDetails, setBeneficiaryDetails] = useState(null);
	const [selectType, setSelectType] = useState('SEND_MONEY');
	const [controls, setControls] = useState({ ...initControls });
	const [modal, setModal] = useState({ name: '', modalData: null });
	const [loding, setLoding] = useState(false);
	const [lodingDelete, setLodingDelete] = useState(false);
	const [overlayer, setOverlayer] = useState(false);
	const [deleteUserData, setDeleteUserData] = useState({});
	const [message, setMessage] = useState({});
	const [otpMsg, setOtpMsg] = useState('');
	const [pgination, setPagination] = useState({ totalPage: 1, currentPage: 0, pageSize: 5 });
	const [filterText, setFilterText] = useState('');
	const [filterAccount, setFilterAccount] = useState('');
	const [filterType, setFilterType] = useState('name');
	const [filterData, setFilterData] = useState([]);
	const [referenceKey, setReferenceKey] = useState(null);
	const [deviceType, setDeviceType] = useState('Mantra');
	const [fingerprintLoader, setFingerprintLoader] = useState(false);
	const [timeover, setTimeover] = useState(false);
	const [aadhaarNumber, setAadhaarNumber] = useState('');
	const [isOTPRequired, setIsOTPRequired] = useState(false);
	const [otp, setOtp] = useState('');
	const [wadh, setWadh] = useState('');
	const [showList, setShowList] = useState(false);
	const [senderData, setSenderData] = useState({});
	const [listingLoading, setListingLoading] = useState(false);

	const { setAlert, geolocation, setGeolocation, refresh, setRefresh } = useContext(GlobleContaxt);

	useEffect(() => {
		const dType = localStorage.getItem('deviceType');
		if (dType) {
			setDeviceType(dType);
		}
	}, []);

	const numberReg = /^[0-9]+$/;
	const nameReg = /^[A-Za-z\s]+$/i;
	const onChangeHandler = (e) => {
		const { name, value } = e.target;
		if (name === 'mobileNumber') {
			if (!numberReg.test(value) && value) {
				return false;
			}
		} else {
			if (!nameReg.test(value) && value) {
				return false;
			}
		}

		const _controls = {
			...controls,
			[name]: value,
		};

		setControls(_controls);
	};

	const verifySenderStatus = async (mobileNumber) => {
		if (isEmpty(geolocation?.latitude)) {
			setAlert({ type: 'warning', msg: 'Please allow access to your location', place: 'globle' });
			getLocation().then((position) => {
				setGeolocation(position);
				checkSenderRegister_(mobileNumber, position);
			});

			return;
		}
		checkSenderRegister_(mobileNumber, geolocation);
	};

	const checkSenderRegister_ = async (mobileNumber, position) => {
		checkSenderRegister(
			mobileNumber,
			position,
			setMessage,
			setLoding,
			setBeneficiaryDetails,
			setControls,
			controls,
			setAlert,
			setSelectType,
			setReferenceKey,
			setIsOTPRequired,
			setWadh,
			setTimeover,
			setOtp,
			setSenderData,
			gebeneficiaryList
		);
	};

	const registerSender = async (resend = '') => {
		if (isEmpty(controls?.mobileNumber)) {
			setMessage({ type: 'error', msg: 'Please enter mobile number', place: 'form' });
			return false;
		} else if (controls?.mobileNumber.length < 10) {
			setMessage({ type: 'error', msg: 'Please enter valid mobile number  ', place: 'form' });
		} else if (isEmpty(controls?.firstName)) {
			setMessage({ type: 'error', msg: 'Please enter first name', place: 'form' });
			return false;
		} else if (isEmpty(controls?.lastName)) {
			setMessage({ type: 'error', msg: 'Please enter last name', place: 'form' });
			return;
		} else if (isOTPRequired && isEmpty(otp)) {
			setMessage({ type: 'error', msg: 'Please enter otp', place: 'form' });
			return;
		}

		if (resend === 'resend') {
			setLodingDelete(true);
		} else {
			setLoding(true);
		}

		const params = {
			firstName: controls.firstName,
			lastName: controls.lastName,
			senderMobile: controls.mobileNumber,
			lattitude: geolocation?.latitude.toFixed(4),
			longitude: geolocation?.longitude.toFixed(4),
			otp: otp,
			refferenceID: referenceKey,
		};

		registerSender_(params, setLoding, setSelectType, setAlert,gebeneficiaryList);
	};

	const onPayClick = (data) => {
		setModal({ name: 'PAY_MODAL', modalData: data });
	};
	const onAddBeneficiaryClick = (data = null) => {
		setModal({ name: 'ADD_BENEFICIARY_MODAL', modalData: data });
	};

	const onCloseModal = () => {
		setModal({ name: '', modalData: null });
	};

	const onSubmitOtp = (otp = '') => {
		setOtpMsg('');
		if (isEmpty(otp)) {
			setOtpMsg('Please enter otp');
			return;
		}
		if (modal?.name === 'VERIFY_TRANSACTION_OTP_MODAL') {
			const payload = {
				senderMobile: modal.params?.senderMobile,
				beneId: modal.params?.beneId,
				beneName: modal.params?.beneName,
				bankId: modal.params?.bankId,
				bankName: modal.params?.bankName,
				accountNo: modal.params?.accountNo,
				ifsc: modal.params?.ifsc,
				securityKey: "",
				amount: modal.params?.amount,
				lattitude: geolocation?.latitude.toFixed(4),
				longitude: geolocation.longitude.toFixed(4),
				transMode: modal.params?.transMode,
				refferenceID: modal?.modalData?.data?.referenceId,
				otp: otp,
			};
		
			verifyTxnOtp(payload, setAlert, setLoding, setRefresh, refresh, setModal);
		}

	};

	const ochangeMobileNumber = (e) => {
		if (isEmpty(localStorage.getItem('ID Token'))) {
			setAlert({ type: 'error', msg: 'Please login first to continue' });
			return;
		}

		if (!numberReg.test(e.target.value) && e.target.value) {
			return false;
		}
		setSenderMobile(e.target.value);
	};

	const deleteConfirm = (e, data) => {
		setOverlayer(true);
		setDeleteUserData(data);
	};

	const deleteHandeler = (resend = '') => {
		if ((resend = 'resend')) {
			setLodingDelete(true);
		} else {
			setLoding(true);
		}
		setOverlayer(false);

		const param = {
			beneficiaryId: deleteUserData?.id,
			merchantId: '',
			mobileNumber: senderMobile,
		};

		
	};

	useEffect(() => {
		if (!isEmpty(message)) {
			setTimeout(() => {
				setMessage({});
			}, 5000);
		}
	}, [message]);

	useEffect(() => {
		if (isEmpty(localStorage.getItem('ID Token'))) {
			setControls({ ...initControls });
			setSenderMobile('');
			setBeneficiaryDetails([]);
		}
	}, [localStorage.getItem('ID Token')]);

	const handleFilterChange = (e) => {
		const value = e.target.value.trim();
		const name = e.target.name;
		if (name === 'name') {
			if (!nameReg.test(value) && value) {
				return false;
			}

			setFilterType(name);
			setFilterText(value);
		}
		if (name === 'account') {
			if (!numberReg.test(value) && value) {
				return false;
			}
			setFilterAccount(value);
			setFilterType(name);
		}
	};

	useEffect(() => {
		if (!isEmpty(beneficiaryDetails)) {
			const filteredData = beneficiaryDetails?.filter((item) => {
				if (filterType === 'name') {
					const pattern = new RegExp('^' + filterText, 'i');
					return pattern.test(item?.name);
				} else {
					const pattern = new RegExp('^' + filterAccount, 'i');
					return pattern.test(item?.accountNo);
				}
			});

			setFilterData(filteredData);

			const totalPages = Math.ceil(filteredData.length / pgination.pageSize);

			setPagination({ ...pgination, currentPage: 0, totalPage: totalPages });
		}
	}, [filterText, filterAccount, beneficiaryDetails]);

	function Capture_() {
		const payload = {
			aadhaarNumber: aadhaarNumber,
			senderMobile: senderMobile,
			otp: otp,
			referenceID: referenceKey ?? '',
			lattitude: geolocation?.latitude.toFixed(4),
			longitude: geolocation?.longitude.toFixed(4),
		};
		Capture(setFingerprintLoader, setLoding, setAlert, deviceType, payload, setSelectType, wadh, setReferenceKey, setIsOTPRequired);
	}

	const onChangeAadhar = (e) => {
		const { value } = e.target.value;
		if (!numberReg.test(e.target.value) && e.target.value) {
			return false;
		}
		setAadhaarNumber(e.target.value);
		console.log(e.target.value);
	};

	const submitKec = () => {
	
		if (isEmpty(aadhaarNumber) || aadhaarNumber.length < 12) {
			setMessage({ type: 'error', msg: 'Please enter valid aadhar', place: 'form' });
			return false;
		}
		if (isOTPRequired && isEmpty(otp)) {
			setMessage({ type: 'error', msg: 'Please enter otp', place: 'form' });
		}
		setSelectType('SELECT_EDVICE');
	};

	const otpHandler = (e) => {
		if (!numberReg.test(e.target.value) && e.target.value) {
			return false;
		}
		setOtp(e.target.value);
	};

	useEffect(() => {
		if (!isOTPRequired) {
			setOtp('');
		}
	}, [isOTPRequired]);
	console.log('showList', modal);

	const newsender = () =>{
		setActiveMobilePop(false);
		setSenderMobile("");
		setBeneficiaryDetails(null)
		setControls({ ...initControls })
		setPagination({ totalPage: 1, currentPage: 0, pageSize: 5 });
		setAadhaarNumber("");
		setIsOTPRequired(false);
		setOtp("");
		setWadh("");
		setShowList(false);
		setSenderData({});
		setFilterData([]);
	}

	const sendAmount =(params)=>{
		verifyTxnOtp(params, setAlert, setLoding, setRefresh, refresh, setModal);
	}

	const popupRef = useRef(null)
	useEffect(() =>{
		overLayers(activeMobilePop,"sm")
		clickOutside(activeMobilePop,popupRef,()=>{setActiveMobilePop(false)})
		return(()=>{
			overLayers(false,"sm")
		clickOutside(false,popupRef,()=>{setActiveMobilePop(false)})
		})
	},[activeMobilePop])


	const gebeneficiaryList = () =>{
		const param = {
			senderMobile: senderMobile,
			lattitude:geolocation?.latitude.toFixed(4),
			longitude: geolocation?.longitude.toFixed(4),
		};
		setListingLoading(true);
		
		getListing(param, setBeneficiaryDetails, setActiveMobilePop, setSelectType, setAlert, setListingLoading, setIsOTPRequired, setShowList, setReferenceKey,loding)
	}
	return (
		<Wrapper className={`tab-content-wrapper ${className}`}>
			{selectType !== 'SELECT_EDVICE' && selectType !== 'CAPTURE_FINGER' && (
				<div className="tab-content-left">
					 <h2>Money Transfer </h2>
					<div className="form-field">
						{!isEmpty(message) && message.place === 'globle' && (
							<AlertWrapper className={`${message.type} globle`}>
								<span className="close" onClick={() => setMessage({})}>
									×
								</span>
								{message.msg}
							</AlertWrapper>
						)}
					</div>
					{selectType === 'SEND_MONEY' && (
						<>
							{!showList && isEmpty(senderData)?<div className="form-field">
								<Input  name="senderMobile" value={senderMobile} label="Sender Mobile" inputMode="numeric" maxLength="10" onChange={(e) => ochangeMobileNumber(e)} />
							</div>:
							<div className=''>
								<RadioButtonConfirm
							className="mb10 noHover"
							heading={senderData?.mobile}
							label="Sender Mobile Number"
							name="addMoneyType"
							checked={false}
							error=""
							onClick={() =>{}}
							value=""
							img={user}
						/>
								<RadioButtonConfirm
							className="mb10 noHover"
							heading={`₹${senderData?.totalLimit} / ₹${senderData?.limit}`}
							label="Available Limit"
							name="addMoneyType"
							checked={false}
							error=""
							onClick={() =>{}}
							value=""
							img={userWallet}
						/>
								
							</div>
							}
							{!isEmpty(message) && message.place === 'form' && (
								<AlertWrapper className={message.type}>
									<span className="close" onClick={() => setMessage({})}>
										×
									</span>
									{message.msg}
								</AlertWrapper>
							)}

							{!showList && isEmpty(senderData)?<button type="submit" className="button-outline mt20" onClick={() => verifySenderStatus(senderMobile)}>
								VERIFY SENDER
							</button>
							:	<div style={{fontSize:"10px",cursor:"pointer",marginTop:"4px"}}>	<span onClick={newsender}><i class="fa-solid fa-angle-left"></i> Back</span></div>
							
							}
						</>
					)}
					{selectType === 'ADD_NEW_PAYEE' && (
						<>
							
								<Input type="text" name="mobileNumber" label="Mobile Number" inputMode="numeric" maxLength="10" value={controls?.mobileNumber} disabled={true} />
						
							
								<Input type="text" name="firstName" label="Enter First Name" value={controls?.firstName} onChange={onChangeHandler} />
							

						
								<Input type="text" name="lastName" label="Enter Last  Name" value={controls?.lastName} onChange={onChangeHandler} />
							
							{isOTPRequired && (
								
									<Input type="text" name="OTP" maxLength="6" inputMode="numeric" label="Enter otp" value={otp} onChange={otpHandler} />
							
							)}
							{isOTPRequired && (
								<div className="flex resendOtp">
									{timeover ? (
										<span className="resendBtn" onClick={() => verifySenderStatus(senderMobile)}>
											Resend otp
										</span>
									) : (
										<div className="flex">
											<span>Resend otp after: &nbsp;</span> <Timer setTimeover={setTimeover} time={30} />
										</div>
									)}
								</div>
							)}

							{!isEmpty(message) && (
								<AlertWrapper className={message.type}>
									<span className="close" onClick={() => setMessage({})}>
										×
									</span>
									{message.msg}
								</AlertWrapper>
							)}
							<button type="submit" className="button-outline mt20" onClick={registerSender}>
								ADD NEW SENDER
							</button>
						</>
					)}
					{selectType === 'KYC_SCREEN' && (
						<>
							
								<Input type="text" name="mobileNumber" label="Mobile Number" inputMode="numeric" maxLength="10" value={controls?.mobileNumber} disabled={true} />
							
								<Input type="text" name="aadhaarNumber" label="Enter Aadhar" maxLength={12} value={aadhaarNumber} onChange={onChangeAadhar} />
						
							{isOTPRequired && (
								
									<Input type="text" name="OTP" label="Enter otp" value={otp} onChange={otpHandler} />
								
							)}

							{!isEmpty(message) && (
								<AlertWrapper className={message.type}>
									<span className="close" onClick={() => setMessage({})}>
										×
									</span>
									{message.msg}
								</AlertWrapper>
							)}
							<button type="submit" className="button-outline mt20" onClick={submitKec}>
								Process
							</button>
						</>
					)}
				</div>
			)}
			{selectType == 'SELECT_EDVICE' && <SelectDeviceType setDeviceType={setDeviceType} deviceType={deviceType} setAepsStatus={setSelectType} aepsStatus={'sendMoney'} />}

			{selectType == 'CAPTURE_FINGER' && <CaptureFingerprint aepsStatus={'sendMoney'} fingerprintLoader={fingerprintLoader} Capture={Capture_} />}
			{showList && (
				<div ref={popupRef} className={`tab-content-right ${!activeMobilePop ? '' : 'active'}`}>
					<div
						className="d-m-block close-pop"
						onClick={() => {
							setActiveMobilePop(false);
						}}
					>
						<IconClose />
					</div>
					<div className="beneficiary-list-heading">
						<div>
							<h2>Beneficiary Details</h2>
							{senderData?.limit && (
								<div className="limit-available">
									Limit Available: <strong>₹{senderData?.limit || "-"}</strong>
								</div>
							)}
						
						</div>
						<div className="limit-with-action">
							{
								<button type="submit" className="button-outline" onClick={onAddBeneficiaryClick}>
									ADD BENEFICIARY
								</button>
							}
						</div>
					</div>
					<div className="filter flex gap-20">
						<div className="bold">Filter By</div>
						<input type="text" placeholder="Name" value={filterText} name="name" onChange={handleFilterChange} />
						<input type="text" placeholder="Account No" value={filterAccount} inputMode="numeric" name="account" onChange={handleFilterChange} />
					</div>
					
						<>
							<TableWrapper className="table-card-wrapper" style={{padding:"0 0"}}>
								<table className="table">
									<thead>
										<tr>
											<th>Sr No</th>
											<th>Beneficiary Name</th>
											<th>Account No.</th>
											<th>IFSC Code</th>
											<th>Bank</th>
											<th>Actions</th>
										</tr>
									</thead>
									<tbody>
										{filterData &&
											filterData.slice(pgination.currentPage * pgination.pageSize, pgination.currentPage * pgination.pageSize + pgination.pageSize).map((data, i) => (
												<tr key={i}>
													<td className="td-none">
														<span className="card-th">Sr No</span>
														<span>{pgination.currentPage * pgination.pageSize + i + 1}</span>
													</td>
													<td className="bold">
														<span className="card-th">Beneficiary Name</span>
														<span>{data?.name}</span>
													</td>
													<td>
														<span className="card-th">Account No.</span>
														<span>{data?.accountNo}</span>
													</td>
													<td>
														<span className="card-th">IFSC Code</span>
														<span>{data?.ifsc}</span>
													</td>
													<td>
														<span className="card-th">Bank</span>
														<span>{data?.bankName}</span>
													</td>
													<td style={{ display: 'flex', gap: '5px' }}>
														<button type="button" style={{ minWidth: '80px' }} className="button-outline" onClick={() => onPayClick(data)}>
															PAY
														</button>
														{/* <button type="button" style={{ minWidth: '80px' }} className="button-outline" onClick={(e) => deleteConfirm(e, data)}>
															Delete
														</button> */}
													</td>
												</tr>
											))}
										{isEmpty(filterData) && (
											<tr>
												<td colSpan={6} style={{ textAlign: 'center', color: 'red' }}>
													No data found
												</td>
											</tr>
										)}
									</tbody>
								</table>
								{modal?.name === 'TRANSACTION_SUCCESS_MODAL' && <Receipt onCloseModal={onCloseModal} modalData={modal?.modalData} />}
			{modal?.name === 'PAY_MODAL' && (
				<PayModal
					modalData={modal?.modalData}
					setModal={setModal}
					mobileNumber={senderMobile}
					referenceKey={referenceKey}
					onCloseModal={onCloseModal}
					verifySenderStatus={verifySenderStatus}
					setLoding={setLoding}
					sendAmount={sendAmount}
				/>
			)}
			{modal?.name === 'ADD_BENEFICIARY_MODAL' && (
				<AddBeneficiaryModal modalData={modal?.modalData} mobileNumber={senderMobile} onCloseModal={onCloseModal} verifySenderStatus={verifySenderStatus} setModal={setModal} referenceKey={referenceKey} />
			)}
			
			{modal?.name === 'VERIFY_SENDER_OTP_DELETE' && (
				<OtpModal
					modalData={modal?.modalData}
					onCloseModal={onCloseModal}
					onSubmitOtp={onSubmitOtp}
					setOtpMsg={setOtpMsg}
					otpMsg={otpMsg}
					lodingDelete={lodingDelete}
					resendOtp={deleteHandeler}
				/>
			)}
			{modal?.name === 'VERIFY_TRANSACTION_OTP_MODAL' && (
				<OtpModal modalData={modal?.modalData} onCloseModal={onCloseModal} onSubmitOtp={onSubmitOtp} setOtpMsg={setOtpMsg} otpMsg={otpMsg} lodingDelete={lodingDelete} />
			)}
			{modal?.name === 'VERIFY_BENEFICIARY_OTP' && (
				<OtpModal modalData={modal?.modalData} onCloseModal={onCloseModal} onSubmitOtp={onSubmitOtp} setOtpMsg={setOtpMsg} otpMsg={otpMsg} lodingDelete={lodingDelete} resendOtp={() => {}} />
			)}
			{overlayer && <Conform setOverlayer={setOverlayer} deleteUserData={deleteUserData} deleteHandeler={deleteHandeler} />}

							</TableWrapper>
							{pgination?.totalPage > 1 && (
								<Pagination currentPage={pgination.currentPage} totalPages={pgination?.totalPage} getCurrentPageData={(page) => setPagination({ ...pgination, currentPage: page })} />
							)}
						</>
				</div>
			)}
			{!showList && (
				<div className="tab-content-right">
					<OfferBanner />
				</div>
			)}

{modal?.name === 'VERIFY_SENDER_OTP_MODAL' && (
				<OtpModal
					modalData={modal?.modalData}
					onCloseModal={onCloseModal}
					onSubmitOtp={onSubmitOtp}
					setOtpMsg={setOtpMsg}
					otpMsg={otpMsg}
					lodingDelete={lodingDelete}
					resendOtp={registerSender}
				/>
			)}

			
			{(loding || listingLoading ) && <Loader />}
		</Wrapper>
	);
}
